import React from 'react';
import { Link } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';
import Production from '@mui/icons-material/Microwave';
import ReadCSVIcon from '@mui/icons-material/UploadFile';
import VegIcon from '@mui/icons-material/Spa';
import PontoIcon from '@mui/icons-material/AccessTime';
import MartinIcon from '@mui/icons-material/Store';
import CaixaIcon from '@mui/icons-material/AttachMoney';
import InsightsIcon from '@mui/icons-material/Insights';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PaidIcon from '@mui/icons-material/Paid';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';

import { useAuth } from './AuthContext';

const Sidebar = () => {
    const { logout, user } = useAuth();
    const userRoles = user?.roles || [];

    console.log('USER:', user);
    console.log('ROLES:', userRoles);

    // roles: undefined/null = visível para todos os autenticados
    const navItems = [
        { text: 'Início', path: '/', icon: <HomeIcon />, roles: ['admin'] },
        { text: 'Produção', path: '/producao', icon: <Production />, roles: ['admin'] },
        { text: 'Ler CSV', path: '/ler-csv', icon: <ReadCSVIcon />, roles: ['admin'] },
        { text: 'Vegetais', path: '/vegetais', icon: <VegIcon />, roles: ['admin'] },
        { text: 'Ponto', path: '/ponto', icon: <PontoIcon />, roles: ['admin', 'gerente'] },
        { text: 'Caixa', path: '/caixa', icon: <CaixaIcon />, roles: ['admin', 'gerente'] },
        { text: 'Martin', path: '/martin', icon: <MartinIcon />, roles: ['admin'] },
        { text: 'Dashboard', path: '/dashboard', icon: <InsightsIcon />, roles: ['admin'] },
        { text: 'Abertura', path: '/abertura', icon: <AccessTimeIcon />, roles: ['admin'] },
        { text: 'Vendas Hora', path: '/vendas-hora', icon: <PaidIcon />, roles: ['admin'] },
        { text: 'Prever Vendas', path: '/prever', icon: <QueryStatsIcon />, roles: ['admin'] },
        { text: 'Inteligência', path: '/inteligencia', icon: <ModelTrainingIcon />, roles: ['admin'] },
        { text: 'Pagamentos', path: '/pagamentos', icon: <LocalAtmIcon />, roles: ['admin'] },
    ];

    const itemsVisiveis = navItems.filter(
        (item) => !item.roles || item.roles.some((r) => userRoles.includes(r))
    );

    return (
        <List>
            {itemsVisiveis.map((item) => (
                <ListItem key={item.text} disablePadding>
                    <ListItemButton component={Link} to={item.path}>
                        <ListItemIcon>
                            {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item.text} />
                    </ListItemButton>
                </ListItem>
            ))}

            <ListItem disablePadding>
                <ListItemButton onClick={logout}>
                    <ListItemIcon>
                        <LogoutIcon />
                    </ListItemIcon>
                    <ListItemText primary="Logout" />
                </ListItemButton>
            </ListItem>
        </List>
    );
};

export default Sidebar;